import { Grid, Paper } from "@mui/material";
import React from "react";
import ApexCharts from "react-apexcharts";

const colors = [
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#F4D03F",
  "#8E44AD",
  "#E67E22",
  "#1ABC9C",
  "#E74C3C",
  "#3498DB",
  "#9B59B6",
  "#34495E",
  "#2ECC71",
  "#16A085",
  "#2980B9",
  "#D35400",
  "#C0392B",
  "#7D3C98",
  "#D5D8DC",
];

const ProductsByStoreChart = ({ data, onBarClick }) => {
  // const options = {
  //   chart: {
  //     type: "bar",
  //     events: {
  //       dataPointSelection: (event, chartContext, { dataPointIndex }) => {
  //         onBarClick(dataPointIndex);
  //       },
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       distributed: true,
  //       dataLabels: {
  //         position: "top",
  //       },
  //     },
  //   },
  //   dataLabels: {
  //     enabled: true,
  //     style: {
  //       colors: ["#000"],
  //     },
  //   },
  //   xaxis: { categories: data.categories },
  //   colors: data.colors,
  // };

  return (
    <Grid item xs={12}>
      <Paper elevation={3} sx={{ padding: "20px" }}>
        <ApexCharts
          options={{
            title: {
              text: "Products by Store",
            },
            tooltip: {
              enabled: true,
              z: {
                title: "Displays the total products available in each store.",
              },
            },
            chart: {
              type: "bar",
              events: {
                dataPointSelection: (
                  event,
                  chartContext,
                  { dataPointIndex }
                ) => {
                  onBarClick(dataPointIndex); // Notify the parent when a bar is clicked
                },
              },
              toolbar: {
                show: true,
                tools: {
                  download: true,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
                autoSelected: "zoom", // Sets the default selected tool
              },
              height: 350,
              legend: {
                show: false,
              },
            },
            xaxis: { categories: data.categories },
            plotOptions: {
              bar: {
                horizontal: false,
                distributed: true,
                borderRadius: 3,
              },
            },
            legend: {
              show: false,
            },
            colors: colors,
          }}
          series={data.series}
          type="bar"
          height={400}
        />
      </Paper>
    </Grid>
  );

  // return <ApexCharts options={options} series={data.series} type="bar" height={400} />;
};

export default ProductsByStoreChart;
